import React from 'react';
import { LOGO_WHITE } from '../../assets/images';
import styles from './MobileHeader.module.css';

export default function MobileHeader() {
    return (
        <header className={styles.header}>
            <div className={styles.tag}>
                Empréstimo com<br />Débito na Conta de Luz
            </div>
            <img src={LOGO_WHITE} alt="Eu Quero Grana" className={styles.logo} />
        </header>
    );
}